import React from 'react';
import ReactDom from "react-dom";
import {
  HashRouter as Router,
  Route,
  Link,
  Redirect,
} from 'react-router-dom';

import TempleList from './js/TempleList';
import Temple from './js/Temple';
import Dashboard from './js/Dashboard';
import UserTempleList from './js/UserTempleList';
import ApiService from './js/ApiService';

import "bootswatch/flatly/bootstrap.css";
import "./styles/font-awesome.min.css";
import "./styles/style.less";


/**
 * convert id to name (replacing _ to  space)
 * @param {string} id id to convert to proper name
 */
function idToName(id, temples = []) {
  const temple = temples.find(temple => temple.id === id);
  if (temple) {
    return temple.name;
  }
  return id.replace(/_/g, ` `);
}

class Main extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      drawerOpen: false,
      navTitle: `Daily Darshan`,
    };

    ApiService.loadJSON(__API_URL__)
      .then(data => {

        this.setState({
          temples: data,
        });
      });

    ApiService.loadJSON(__API_URL__ + `/loginstatus`)
      .then(data => {

        this.setState({
          auth: data.auth,
          user: data.user,
        });
      });

  }

  /*
   * toggles side menu drawer
   */
  toggleDrawer() {
    this.setState({
      drawerOpen: !this.state.drawerOpen,
    });
  }

  render() {

    let drawerOpenCloseKlass = this.state.drawerOpen ? `drawer-open` : `drawer-close`;

    return (
      <Router>
        <div>

          <MenuDrawer drawerKlass={drawerOpenCloseKlass} toggleDrawerAction={this.toggleDrawer.bind(this)} />

          <div className={`container-fluid content-cont ` + drawerOpenCloseKlass}>

            <div className="row header">
              <Route exact path="/" render={props => (
                <NavBar
                  {...props}
                  navTitle="Daily Darshan"
                  toggleDrawer={this.toggleDrawer.bind(this)} />
              )} />

              <Route path="/(user/temple|temple)/:templeId?" render={props => {

                if (props.match.params.templeId) {
                  return (
                    <NavBar
                      {...props}
                      navTitle={idToName(props.match.params.templeId, this.state.temples)}
                      backButton
                      backLink={(props.location.pathname.match(/user\/temple/) ? `/dashboard/temple` : `/`)}
                      userLoggedIn={(props.location.pathname.match(/user\/temple/) ? true : false)} />
                  );
                } else {

                  return (
                    <NavBar
                      {...props}
                      navTitle="Daily Darshan"
                      toggleDrawer={this.toggleDrawer.bind(this)}
                      userLoggedIn={(props.location.pathname.match(/user\/temple/) ? true : false)} />
                  );
                }
              }} />
              <Route path="/dashboard/:page" render={props => (
                <NavBar
                  {...props}
                  navTitle={props.match.params.page}
                  toggleDrawer={this.toggleDrawer.bind(this)}
                  userLoggedIn />
              )} />
              <Route path="/user/temples" render={props => (
                <NavBar
                  {...props}
                  navTitle="Daily Darshan"
                  toggleDrawer={this.toggleDrawer.bind(this)} />
              )} />
            </div>

            <div className="row main-cont" id="mainCont">

              <div className="loading-overlay" id="ajax-loader">
                <div className="loader">
                </div>
              </div>

              <Route exact path="/" render={() => {

                if (this.state.auth === undefined) {
                  return;
                }
                if (this.state.auth) {

                  if (this.state.user.role === `admin`) {
                    return (
                      <Redirect to="/dashboard" />
                    );
                  } else {
                    return (
                      <Redirect to="/user/temples" />
                    );
                  }
                } else {
                  return (
                    <Redirect to="/temple" />
                  );
                }
              }} />

              <Route path="/temple/:templeId?/:year?/:month?/:day?" render={props => {

                if (this.state.auth) {
                  return (
                    <Redirect to="/" />
                  );
                }
                if (props.match.params.templeId) {
                  return (
                    <Temple {...props} temples={this.state.temples} />
                  );
                } else {
                  return (
                    <TempleList {...props} temples={this.state.temples} />
                  );
                }
              }} />

              <Route path="/dashboard" component={Dashboard} />

              <Route path="/user/temples" render={props => (
                <UserTempleList userLoggedIn {...props} />
              )} />

              <Route path="/user/temple/:templeId/:year?/:month?/:day?" render={props => (
                <Temple {...props} userLoggedIn temples={this.state.temples} />
              )} />

            </div>

          </div>
        </div>
      </Router>
    );
  }
}

const NavBar = props => (

  <nav className="navbar navbar-default navbar-fixed-top main-navbar">

    {
      props.toggleDrawer && (
        <div className="navbar-toggle menu-cont" onClick={props.toggleDrawer}>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </div>
      )
    }

    {
      props.backButton && (
        <Link to={props.backLink} className="back-button menu-cont">
          <span className="fa fa-arrow-left"></span>
        </Link>
      )
    }

    <div className="navbar-text text-center text-capitalize" id="navTitle">
      <Link to="/"><h4>{props.navTitle}</h4></Link>
    </div>
  </nav>
);

const MenuDrawer = props => (

  <div className={`drawer-cont ` + props.drawerKlass}>
    <div className="drawer">
      <ul className="drawer-menu-cont">

        {
          window.location.href.match(/dashboard/) === null &&
          window.location.href.match(/user\/temples/) === null &&
            <li className="drawer-item">
              <a href={`/auth/google`} onClick={props.toggleDrawerAction}>
                <span className="item-label">
                  <span className="fa fa-google"></span>
                  <span className="menu-label">Google Login</span>
                </span>
              </a>
            </li>
            /* <li className="drawer-item">
              <a href={`/auth/facebook`} onClick={props.toggleDrawerAction}>
                <span className="item-label">
                  <span className="fa fa-facebook"></span>
                  <span className="menu-label">Facebook Login</span>
                </span>
              </a>
            </li> */
        }

        {
          (window.location.href.match(/dashboard/) ||
            window.location.href.match(/user\/temples/)) &&
            <li className="drawer-item">
              <a href={__API_URL__ + `/logout`}>
                <span className="item-label">
                  Logout
                </span>
              </a>
            </li>
        }
      </ul>
    </div>
  </div>
);

ReactDom.render(<Main />, document.getElementById(`app`));




// WEBPACK FOOTER //
// ./main.js